<template>
    <div>
        <div class="IncomeDetailed container-inner">
            <!-- Question 1 -->
            <slider-question v-bind:key="1" v-if="this.$store.state.step == 1" v-bind="{
                title: 'Income',
                description: 'What is your total annual pre-tax income including super?<br> (This would determine the maximum cover you may able to apply for)',
                min: 0,
                type: 'money',
                format: 'thousands',
                max: 120000,
                tick: 40000,
                step: 1000,
                value: this.$store.state.income,
                customVal: this.$store.state.customIncome,
                name: 'income',
                customName: 'customIncome',
                previous: 1,
                next: 2
            }"></slider-question>

            <!-- Question 2 -->
            <slider-question v-bind:key="2" v-if="this.$store.state.step == 2" v-bind="{
                title: 'Other Income',
                description: 'What is your annual after-tax income from sources other than your salary and wages? <br>(e.g.partner\'s income, investments, government support etc.)',
                note: 'Please note that any income from other sources could affect the maximum income protection benefit available to you.',
                min: 0,
                type: 'money',
                format: 'thousands',
                max: 20000,
                tick: 5000,
                step: 1000,
                value: this.$store.state.incomeOther,
                customVal: this.$store.state.customIncomeOther,
                name: 'incomeOther',
                customName: 'customIncomeOther',
                previous: 1,
                next: 3
            }"></slider-question>

            <!-- Question 3 -->
            <slider-question v-bind:key="3" v-if="this.$store.state.step == 3" v-bind="{
                title: 'Debt Repayments',
                description: 'What is your estimated monthly debt repayment? <br>(e.g. mortgages, personal loans, etc.)',
                min: 0,
                type: 'money',
                format: 'thousands',
                max: 5000,
                tick: 1000,
                step: 250,
                value: this.$store.state.debtRepayment,
                customVal: this.$store.state.customDebtRepayment,
                name: 'debtRepayment',
                customName: 'customDebtRepayment',
                previous: 2,
                next: 4
            }"></slider-question>

            <!-- Question 4 -->
            <slider-question v-bind:key="4" v-if="this.$store.state.step == 4" v-bind="{
                title: 'Expenses',
                description: 'What is your estimated weekly household spending beside debt repayments? <br>(e.g. groceries, utilities, school fees, etc.)',
                min: 0,
                type: 'money',
                max: 5000,
                tick: 1000,
                step: 250,
                value: this.$store.state.expenses,
                customVal: this.$store.state.customExpenses,
                name: 'expenses',
                customName: 'customExpenses',
                previous: 3,
                next: 'results'
            }"></slider-question>
        </div>
        <slot/>
    </div>
</template>

<script>
    import SliderQuestion from '../components/questions/SliderQuestion.vue';
    import ButtonQuestion from '../components/questions/ButtonQuestion.vue';
    import MultiSliderQuestion from '../components/questions/MultiSliderQuestion.vue';
    import school from '@/assets/icons/school.svg';
    import person from '@/assets/icons/person.svg';
    import personWithChild from '@/assets/icons/personwithchild.svg';

    export default {
        name: 'DetailedIncome',
        components: {
            SliderQuestion,
            ButtonQuestion,
            MultiSliderQuestion
        },
        created: function() {
            this.$store.commit('update', { name: 'calculator', value: 'detailed' });
            this.$store.commit('update', { name: 'product', value: 'income' });
        },
        data() {
            return {
                school,
                person,
                personWithChild
            };
        }
    }
</script>

<style lang="scss" scoped>
    .IncomeDetailed {
        text-align: center;
    }
</style>
